import React, { useState, useEffect } from "react";
// useLocation hook'unu ekledik (sayfa değişimini yakalamak için)
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// Google Analytics kütüphanesini ekledik
import ReactGA from "react-ga4";
import { CartProvider } from "./hooks/useCart"; // Import CartProvider

import "./App.css";

// Bileşenler
import Header from "./components/Header";
import Footer from "./components/Footer";
import Index from "./components/Index";
import Hakkimizda from "./pages/Hakkimizda";
import İletisim from "./pages/İletisim";
import Uyegirisi from "./pages/Uyegirisi";
import Uyeol from "./pages/Uyeol";
import Kurumsal from "./pages/Kurumsal";

import Projeler from "./pages/Projeler";
import { supabase } from "./supabaseClient/supabaseClient";
import SatinAl from "./pages/SatinAl";
import SifreGuncelle from "./pages/SifreGuncelle";
import Profile from "./pages/Profile"; // Profile import
import HesapOnaylandi from "./pages/HesapOnaylandi";

import CartPage from './pages/CartPage';
import Sozlesmeler from "./pages/Sozlesmeler";
import NotFound from "./pages/NotFound";
import Success from "./pages/Success";
import Failure from "./pages/Failure";


// Buraya kendi "G-XXXXXXXXXX" kodunuzu yazın
ReactGA.initialize("G-H4553C0EZZ");

// --- 2. SAYFA TAKİP BİLEŞENİ ---
// React Router her sayfa değiştirdiğinde GA'ya haber verir
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Sayfa her değiştiğinde GA4'e pageview gönder
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; // Görüntülenen bir şey yok, sadece arka planda çalışır
}


function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <CartProvider>
      <Router>
        {/* --- 3. TAKİPÇİYİ BURAYA EKLİYORUZ --- */}
        {/* Router'ın hemen içine koymalısınız ki useLocation çalışsın */}
        <AnalyticsTracker />

        <div className="App">
          <Header session={session} />

          <Routes>
            <Route path="/Index" element={<Index />} />
            <Route path="/" element={<Index />} />
            <Route path="/Hakkimizda" element={<Hakkimizda />} />
            <Route path="/İletisim" element={<İletisim />} />
            <Route path="/Uyegirisi" element={<Uyegirisi />} />
            <Route path="/Uyeol" element={<Uyeol />} />
            <Route path="/Kurumsal" element={<Kurumsal />} />
            <Route path="/satinAl" element={<SatinAl />} />
            <Route path="/SifreGuncelle" element={<SifreGuncelle />} />
            <Route path="/Profil" element={<Profile />} /> {/* Profile Route */}
            <Route path="/Sepet" element={<CartPage />} />
            <Route path="/sozlesme/:type" element={<Sozlesmeler />} />
            <Route path="/Projeler" element={<Projeler />} />
            <Route path="/HesapOnaylandi" element={<HesapOnaylandi />} />
            <Route path="/basarili" element={<Success />} />
            <Route path="/basarisiz" element={<Failure />} />
            <Route path="*" element={<NotFound />} /> {/* Catch-all Route */}
          </Routes>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;